'use client';

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { isInventoryAuditorContext, isTomsVendingContext } from '@/constants/business-units';

/** Blocks non–Mint-Adventures contexts from Mint Adventures–only app areas. */
export function RequireSouthernMint() {
  const { user } = useAuth();
  const location = useLocation();

  if (isTomsVendingContext(user)) {
    return (
      <Navigate
        to="/app/toms-vending/locations"
        replace
        state={{ redirectedFrom: location.pathname }}
      />
    );
  }

  if (isInventoryAuditorContext(user)) {
    return (
      <Navigate
        to="/app/dashboard"
        replace
        state={{ redirectedFrom: location.pathname }}
      />
    );
  }

  return <Outlet />;
}
